import {Component, ViewChild} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {ButtonProminence} from "../../buttons/button/button";
import {Page} from "../../orchestration/page";
import {FormComponent} from "../../inputs/form/form.component";
import {MessageLevel} from "../../notification/message/message";
import {SessionModel} from "../../orchestration/session.model";
import {AppFeedbackService} from "../app-feedback.service";

@Component({
    selector: "woa-feedback-page",
    templateUrl: "./feedback-page.component.html",
    providers: [
        AppFeedbackService,
        {provide: Page, useExisting: FeedbackPageComponent}
    ]
})
export class FeedbackPageComponent extends Page {
    @ViewChild(FormComponent) public form: FormComponent;

    ButtonProminence = ButtonProminence;
    MessageLevel = MessageLevel;

    category: string;
    message: string;
    sent: boolean;

    constructor(public sessionModel: SessionModel,
                public navigationService: NavigationService,
                private appFeedbackService: AppFeedbackService) {
        super();
    }

    send(): void {
        if (!this.form.valid) {
            return;
        }

        // noinspection JSIgnoredPromiseFromCall
        this.appFeedbackService.performAction({
            category: this.category,
            message: this.message
        });
        this.sent = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/feedback-page/feedback-page.component.ts